import { axiosInstance } from "../axios_Instanse";

import { findOrdersHistory } from "../Orders/OrderActionCreators";
import Store from "../Store";

export const FindOrdersHistory = async () => {
  const { endDate, page, perPage, search, startDate } =
    Store.getState().historyReducer;
  try {
    Store.dispatch(findOrdersHistory([]));

    const { data } = await axiosInstance.post("/orders", {
      search,
      start_date: startDate,
      end_date: endDate,
      perPage,
      page,
    });
    Store.dispatch(findOrdersHistory(data));
    return data;
  } catch (error) {
    // console.log(`${error}`);
  }
};
